export default {
  inject: ['load'],
  data() {
    return {
      allVertigoTypesForOther: [],
      vertigoType: null,
    };
  },
  methods: {
    getListOfVertigoTypesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVertigoTypes').then(() => {
        if (this.$store.state.vertigoTypeModule.successFlag) {
          this.allVertigoTypesForOther = this.$store.state.vertigoTypeModule.allVertigoTypes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVertigoTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getVertigoTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVertigoType', id).then(() => {
        if (this.$store.state.vertigoTypeModule.successFlag) {
          this.vertigoType = this.$store.state.vertigoTypeModule.vertigoType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVertigoTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vertigoTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
